import api from './api';

export const medicamentoRegistradoService = {
  // Listar todos os medicamentos registrados
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/medicamentos-registrados', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Buscar por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/medicamentos-registrados/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Criar novo medicamento registrado
  create: async (dados) => {
    try {
      const response = await api.post('/medicamentos-registrados', dados);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Editar medicamento registrado com senha
  adminEdit: async (id, dados, senha) => {
    try {
      const response = await api.put(`/medicamentos-registrados/${id}/admin-edit`, {
        ...dados,
        senha
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Deletar medicamento registrado com senha
  adminDelete: async (id, senha) => {
    try {
      const response = await api.delete(`/medicamentos-registrados/${id}/admin-delete`, {
        data: { senha }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Buscar categorias disponíveis
  getCategorias: async () => {
    try {
      const response = await api.get('/medicamentos-registrados/meta/categorias');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default medicamentoRegistradoService;